import React from "react";
import { Create } from "@refinedev/antd";
import { useCustomMutation } from "@refinedev/core";
import { message, Form } from "antd";
import { PurchaseRequestForm } from "./components/PurchaseRequestForm";
import {
  CREATE_PURCHASE_REQUEST_MUTATION,
  SUBMIT_PURCHASE_REQUEST_MUTATION,
} from "./queries";

export const CreatePurchaseRequest: React.FC = () => {
  const [form] = Form.useForm();

  // Create draft
  const { mutate: createMutate, isLoading: creating } = useCustomMutation();
  // Submit PR (create + submit path via requestData)
  const { mutate: submitMutate, isLoading: submitting } = useCustomMutation();

  const onSaveDraft = async (values: any) => {
    createMutate(
      {
        url: "",
        method: "post",
        values: {
          input: values,
        },
        meta: { gqlMutation: CREATE_PURCHASE_REQUEST_MUTATION },
      },
      {
        onSuccess: () => {
          message.success("Purchase Request saved as draft");
        },
        onError: (e) => {
          console.error(e);
          message.error("Failed to save draft");
        },
      },
    );
  };

  const onSubmit = async (payload: { requestId?: string; requestData?: any; fiscalYear: number }) => {
    // In create page we expect requestData path
    const requestData = payload.requestData ?? {};
    submitMutate(
      {
        url: "",
        method: "post",
        values: {
          input: {
            requestData: requestData,
            fiscalYear: Number(payload.fiscalYear),
          },
        },
        meta: { gqlMutation: SUBMIT_PURCHASE_REQUEST_MUTATION },
      },
      {
        onSuccess: () => {
          message.success("Purchase Request submitted");
        },
        onError: (e) => {
          console.error(e);
          message.error("Failed to submit request");
        },
      },
    );
  };

  return (
    <Create
      title="Create Purchase Request"
      saveButtonProps={{ loading: creating || submitting, style: { display: "none" } }}
      footerButtons={() => null}
    >
      <PurchaseRequestForm
        form={form}
        isEdit={false}
        onSaveDraft={onSaveDraft}
        onSubmit={onSubmit}
      />
    </Create>
  );
};